/*
 * @Author: Teemo Ding
 * @Date: 2021-11-15 11:15:02
 * @LastEditTime: 2022-06-08 10:13:34
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/ParcelProcess/Collected/index.tsx
 */
import { get } from 'lodash';
import moment from 'moment';
import React from 'react';
//import css from './css.module.less';
import Category from '../Components/Category';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Collected = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };

  const { data, orderNo, collectShop, collectDate, returnFun, disabled } =
    props;
  return (
    <Category
      title={getI18n(`allOrders.orderDetail.collected_return_category_title`)}
      data={data.map((i) => {
        const image = get(i, 'images.0.url');
        const pickedDate = get(i, 'pickedDate', null);
        const packedDate = get(i, 'packedDate', null);
        const lastNotified = get(i, 'lastNotifiedTime', null);
        const pickDate = moment(pickedDate).format('YYYY-MM-DD hh:mm');
        const packDate = moment(packedDate).format('YYYY-MM-DD hh:mm');
        const collectTime = moment(collectDate).format('YYYY-MM-DD hh:mm');
        const lastNotifiedTime =
          moment(lastNotified).format('YYYY-MM-DD hh:mm');
        const parcelNo = get(i, 'parcelNo');
        const uuid = get(i, 'uuid');
        return {
          uuid,
          image,
          sku: `${orderNo}-${parcelNo}`,
          options: [
            {
              title: getI18n(
                `allOrders.orderDetail.collected_return_category_options_pickedtitle`,
              ),
              content: pickDate || '-',
            },
            {
              title: getI18n(
                `allOrders.orderDetail.collected_return_category_options_shoptitle`,
              ),
              content: collectShop,
            },
            {
              title: getI18n(
                `allOrders.orderDetail.collected_return_category_options_packedtitle`,
              ),
              content: packDate,
            },
            {
              title: getI18n(
                `allOrders.orderDetail.collected_return_category_options_statustitle`,
              ),
              content: (
                <div className={css.collectStatus}>
                  <p>
                    {getI18n(
                      'allOrders.orderDetail.collected_return_category_title',
                    )}
                  </p>
                  <span>{collectTime}</span>
                </div>
              ),
            },
            {
              title: getI18n(
                `allOrders.orderDetail.collected_return_category_options_lasttitle`,
              ),
              content: lastNotifiedTime,
            },
          ],
          ...(!disabled && {
            dropOptions: [
              {
                label: getI18n(
                  `allOrders.orderDetail.collected_return_category_dropoptions_label`,
                ),
                onClick: () => returnFun(),
              },
            ],
          }),
        };
      })}
    />
  );
};
export default Collected;
